import { ReactNode } from 'react';
import TriggerControl from '@creditflowresearch/uilib/PanelControl';
import { createHoverInteraction } from './useHoverInteraction';
import PanelButton from '@creditflowresearch/uilib/PanelButton';
import Flex from '@creditflowresearch/uilib/Flex';
import type { INavItem } from './DropdownPanelButtons';

import styles from './dropdownPanelButtons.module.scss';

interface IMobileDropdownPanelButtonsProps {
  items: INavItem[],
  getPanelContent: (panelId: string) => ReactNode,
  className?: string,
}

const MobileDropdownPanelButtons = ({
  items,
  getPanelContent,
  className,
}: IMobileDropdownPanelButtonsProps) => (
  <Flex
    className={ className }
    direction="column"
    dataTest="dropdownPanelButtons"
  >
    { items.map((item) => (
      <TriggerControl
        panelId={ item.id }
        key={ item.id }
        useInteraction={ createHoverInteraction({
          panelId: item.id,
          positioning: 'relative',
        }) }
        trigger={ (isOpen) => (
          <Flex
            className={ styles.buttonItemContainer }
            dataTest="dropdownPanelButton"
          >
            <PanelButton
              label={ item.label }
              badge={ typeof item.badge === 'function' ? item.badge(isOpen) : item.badge }
              data-panel-open={ isOpen }
              aria-expanded={ isOpen }
              aria-controls={ `panel-menu-${ item.id }` }
            />
          </Flex>
        ) }
        control={ getPanelContent(item.id) }
      />
    )) }
  </Flex>
);

export default MobileDropdownPanelButtons;
